import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { StickyCTA } from '../components/StickyCTA';
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-296">
      <HeroSection data-id="element-297" />
      <TrustBar data-id="element-298" />

      <Suspense fallback={null} data-id="element-299">
        <div className="cv-auto" data-id="element-300">
          <ContrastSection data-id="element-301" />
          <ForWhomSection data-id="element-302" />
          <BenefitsSection data-id="element-303" />
          <ContentPreview data-id="element-304" />
          <BonusSection data-id="element-305" />
          <PricingSection data-id="element-306" />
        </div>
      </Suspense>

      <Suspense fallback={null} data-id="element-307">
        <div className="cv-auto" data-id="element-308">
          <GuaranteeSection data-id="element-309" />
          <TestimonialsSection data-id="element-310" />
          <ExpertSection data-id="element-311" />
          <FAQSection data-id="element-312" />
          <Footer data-id="element-313" />
        </div>
        <SocialProofPopup data-id="element-314" />
      </Suspense>

      <StickyCTA data-id="element-315" />
    </main>;
}